import axios from "axios";

const DepApi = axios.create({
  timeout: 300000,
});

switch (process.env.VUE_APP_RUN) {
  case "localhost":
    //DepApi.defaults.baseURL = 'http://localhost:44368/Api/';
    //DepApi.defaults.baseURL = 'http://webf.cych.org.tw/WebAPI_test/Admin/DepApi/api/';
    //DepApi.defaults.baseURL ="http://webf.cych.org.tw/WebAPI/Admin/DepApi/api/";
    DepApi.defaults.baseURL = 'http://weba.cych.org.tw/DepApi/api/';
    break;

  case "test":
    DepApi.defaults.baseURL =
      "http://webf.cych.org.tw/WebAPI_test/Admin/DepApi/api/";
    break;

  case "formal":
    DepApi.defaults.baseURL = "http://weba.cych.org.tw/DepApi/api/";
    break;
}

export default {
  DepApi,
};
